export var PolicyAssessmentEnum;
(function (PolicyAssessmentEnum) {
    PolicyAssessmentEnum["Benefit"] = "Benefit";
    PolicyAssessmentEnum["Neutral"] = "Neutral";
    PolicyAssessmentEnum["Restriction"] = "Restriction";
})(PolicyAssessmentEnum || (PolicyAssessmentEnum = {}));
// note: this enum is created for handling the FTC logic in the FE; it's also used in tracking
export var FtcType;
(function (FtcType) {
    FtcType["FtcNoFees"] = "FTC_no_fees";
    FtcType["FtcWithFees"] = "FTC_fees";
    FtcType["NoFtc"] = "non_refundable";
})(FtcType || (FtcType = {}));
export var AmenityEnums;
(function (AmenityEnums) {
    AmenityEnums[AmenityEnums["AmenityQuality"] = 0] = "AmenityQuality";
    AmenityEnums[AmenityEnums["AmenityExists"] = 1] = "AmenityExists";
    AmenityEnums[AmenityEnums["SeatLegroom"] = 2] = "SeatLegroom";
    AmenityEnums[AmenityEnums["SeatWidth"] = 3] = "SeatWidth";
    AmenityEnums[AmenityEnums["SeatFlatness"] = 4] = "SeatFlatness";
})(AmenityEnums || (AmenityEnums = {}));
export var AmenityQuality;
(function (AmenityQuality) {
    AmenityQuality[AmenityQuality["Standard"] = 0] = "Standard";
    AmenityQuality[AmenityQuality["Better"] = 1] = "Better";
    AmenityQuality[AmenityQuality["Na"] = 2] = "Na";
})(AmenityQuality || (AmenityQuality = {}));
export var SeatFlatness;
(function (SeatFlatness) {
    SeatFlatness[SeatFlatness["Na"] = 0] = "Na";
    SeatFlatness[SeatFlatness["NotFlat"] = 1] = "NotFlat";
    SeatFlatness[SeatFlatness["AngleFlat"] = 2] = "AngleFlat";
    SeatFlatness[SeatFlatness["FullFlat"] = 3] = "FullFlat";
})(SeatFlatness || (SeatFlatness = {}));
export var SeatLegroom;
(function (SeatLegroom) {
    SeatLegroom[SeatLegroom["Less"] = 0] = "Less";
    SeatLegroom[SeatLegroom["Standard"] = 1] = "Standard";
    SeatLegroom[SeatLegroom["More"] = 2] = "More";
    SeatLegroom[SeatLegroom["Na"] = 3] = "Na";
})(SeatLegroom || (SeatLegroom = {}));
export var SeatWidth;
(function (SeatWidth) {
    SeatWidth[SeatWidth["Standard"] = 0] = "Standard";
    SeatWidth[SeatWidth["Wider"] = 1] = "Wider";
    SeatWidth[SeatWidth["Na"] = 2] = "Na";
})(SeatWidth || (SeatWidth = {}));
export var AmenityExists;
(function (AmenityExists) {
    AmenityExists[AmenityExists["Yes"] = 0] = "Yes";
    AmenityExists[AmenityExists["No"] = 1] = "No";
    AmenityExists[AmenityExists["Na"] = 2] = "Na";
})(AmenityExists || (AmenityExists = {}));
export var WifiChance;
(function (WifiChance) {
    WifiChance[WifiChance["Full"] = 0] = "Full";
    WifiChance[WifiChance["VeryGood"] = 1] = "VeryGood";
    WifiChance[WifiChance["Good"] = 2] = "Good";
    WifiChance[WifiChance["Some"] = 3] = "Some";
    WifiChance[WifiChance["Na"] = 4] = "Na";
})(WifiChance || (WifiChance = {}));
export var AmenityCost;
(function (AmenityCost) {
    AmenityCost[AmenityCost["Free"] = 0] = "Free";
    AmenityCost[AmenityCost["Paid"] = 1] = "Paid";
    AmenityCost[AmenityCost["Na"] = 2] = "Na";
})(AmenityCost || (AmenityCost = {}));
export var AmenityMixedCost;
(function (AmenityMixedCost) {
    AmenityMixedCost[AmenityMixedCost["Free"] = 0] = "Free";
    AmenityMixedCost[AmenityMixedCost["FreeOrPaid"] = 1] = "FreeOrPaid";
    AmenityMixedCost[AmenityMixedCost["Paid"] = 2] = "Paid";
    AmenityMixedCost[AmenityMixedCost["Na"] = 3] = "Na";
})(AmenityMixedCost || (AmenityMixedCost = {}));
export var PowerDistribution;
(function (PowerDistribution) {
    PowerDistribution[PowerDistribution["Some"] = 0] = "Some";
    PowerDistribution[PowerDistribution["All"] = 1] = "All";
    PowerDistribution[PowerDistribution["Na"] = 2] = "Na";
})(PowerDistribution || (PowerDistribution = {}));
export var CabinPressure;
(function (CabinPressure) {
    CabinPressure[CabinPressure["Enhanced"] = 0] = "Enhanced";
    CabinPressure[CabinPressure["Normal"] = 1] = "Normal";
    CabinPressure[CabinPressure["Unpressurized"] = 2] = "Unpressurized";
    CabinPressure[CabinPressure["Na"] = 3] = "Na";
})(CabinPressure || (CabinPressure = {}));
export var WindowSize;
(function (WindowSize) {
    WindowSize[WindowSize["Smaller"] = 0] = "Smaller";
    WindowSize[WindowSize["Larger"] = 1] = "Larger";
    WindowSize[WindowSize["Standard"] = 2] = "Standard";
    WindowSize[WindowSize["Na"] = 3] = "Na";
})(WindowSize || (WindowSize = {}));
export var UtaAssessment;
(function (UtaAssessment) {
    UtaAssessment[UtaAssessment["Neutral"] = 0] = "Neutral";
    UtaAssessment[UtaAssessment["Benefit"] = 1] = "Benefit";
    UtaAssessment[UtaAssessment["Restriction"] = 2] = "Restriction";
    UtaAssessment[UtaAssessment["Fee"] = 3] = "Fee";
})(UtaAssessment || (UtaAssessment = {}));
export var UtaCategory;
(function (UtaCategory) {
    UtaCategory[UtaCategory["AdvanceChange"] = 0] = "AdvanceChange";
    UtaCategory[UtaCategory["BoardingPriority"] = 1] = "BoardingPriority";
    UtaCategory[UtaCategory["Cancellation"] = 2] = "Cancellation";
    UtaCategory[UtaCategory["CarryOnAllowance"] = 3] = "CarryOnAllowance";
    UtaCategory[UtaCategory["CheckInPriority"] = 4] = "CheckInPriority";
    UtaCategory[UtaCategory["CheckedBagAllowance"] = 5] = "CheckedBagAllowance";
    UtaCategory[UtaCategory["LoungeAccess"] = 6] = "LoungeAccess";
    UtaCategory[UtaCategory["SameDayChange"] = 7] = "SameDayChange";
    UtaCategory[UtaCategory["SeatSelection"] = 8] = "SeatSelection";
    UtaCategory[UtaCategory["UpgradeEligibility"] = 9] = "UpgradeEligibility";
})(UtaCategory || (UtaCategory = {}));
export var UpaCategory;
(function (UpaCategory) {
    UpaCategory[UpaCategory["Brand"] = 0] = "Brand";
    UpaCategory[UpaCategory["Promotion"] = 1] = "Promotion";
})(UpaCategory || (UpaCategory = {}));
/*
  note: the following constants are values from the 'utas' object;
  ideally, they should be passed to the FE as case classes.
*/
export var UtasPolicyCategory;
(function (UtasPolicyCategory) {
    UtasPolicyCategory["AdvanceChange"] = "advance-change";
    UtasPolicyCategory["Cancellation"] = "cancellation";
})(UtasPolicyCategory || (UtasPolicyCategory = {}));
export var UtasPolicyAssessment;
(function (UtasPolicyAssessment) {
    UtasPolicyAssessment["Benefit"] = "benefit";
    UtasPolicyAssessment["Fee"] = "fee";
    UtasPolicyAssessment["Unavailable"] = "unavailable";
})(UtasPolicyAssessment || (UtasPolicyAssessment = {}));
export var UtasPolicyDescription;
(function (UtasPolicyDescription) {
    UtasPolicyDescription["AdvanceChangeAllowedForFree"] = "Advance change allowed for free";
    UtasPolicyDescription["AdvanceChangeAllowedForAFee"] = "Advance change allowed for a fee";
    UtasPolicyDescription["AdvanceChangeNotAllowed"] = "Advance change not allowed";
})(UtasPolicyDescription || (UtasPolicyDescription = {}));
export var UtasPolicyHeadline;
(function (UtasPolicyHeadline) {
    UtasPolicyHeadline["ForFree"] = "Free";
    UtasPolicyHeadline["ForAFee"] = "For a fee";
    UtasPolicyHeadline["NotAllowed"] = "Not Allowed";
    UtasPolicyHeadline["NonRefundable"] = "Non-refundable";
})(UtasPolicyHeadline || (UtasPolicyHeadline = {}));
//# sourceMappingURL=interfaces.js.map